exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Description_FormTitle_1jvXc {\n    color: #337ab7;\n    margin: auto;\n    align-items: left;\n    display: flex;\n    flex-flow: row;\n    justify-content: left;\n    font-size: 18px;\n    font-weight: bolder;\n    margin: 10px 0px 0 20px;\n}\n\n.Description_box_wIjSq {\n    border: 1px solid grey;\n    /* box-shadow: black; */\n    border-radius: 5px;\n    margin: 5px;\n    padding: 20px;\n}", ""]);

// Exports
exports.locals = {
	"FormTitle": "Description_FormTitle_1jvXc",
	"box": "Description_box_wIjSq"
};